var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { detect } from "detect-browser";
import "cross-fetch/polyfill";
import { AuthInfo, CoreStitchAuth, DeviceFields, StitchAuthResponseCredential, StitchClientError, StitchClientErrorCode } from "mongodb-stitch-core-sdk";
import version from "../../internal/common/Version";
import RedirectFragmentFields from "./RedirectFragmentFields";
import RedirectKeys from "./RedirectKeys";
import StitchRedirectError from "./StitchRedirectError";
import StitchUserFactoryImpl from "./StitchUserFactoryImpl";
var alphaNumericCharacters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
var StitchAuthImpl = (function (_super) {
    __extends(StitchAuthImpl, _super);
    function StitchAuthImpl(requestClient, browserAuthRoutes, authStorage, appInfo, jsdomWindow) {
        if (jsdomWindow === void 0) { jsdomWindow = window; }
        var _this = _super.call(this, requestClient, browserAuthRoutes, authStorage) || this;
        _this.browserAuthRoutes = browserAuthRoutes;
        _this.authStorage = authStorage;
        _this.appInfo = appInfo;
        _this.jsdomWindow = jsdomWindow;
        _this.listeners = new Set();
        return _this;
    }
    Object.defineProperty(StitchAuthImpl.prototype, "userFactory", {
        get: function () {
            return new StitchUserFactoryImpl(this);
        },
        enumerable: true,
        configurable: true
    });
    StitchAuthImpl.prototype.getProviderClient = function (factory, providerName) {
        if (isAuthProviderClientFactory(factory)) {
            return factory.getClient(this, this.requestClient, this.authRoutes);
        }
        else {
            return factory.getNamedClient(providerName, this.requestClient, this.authRoutes);
        }
    };
    StitchAuthImpl.prototype.loginWithCredential = function (credential) {
        return _super.prototype.loginWithCredentialInternal.call(this, credential);
    };
    StitchAuthImpl.prototype.loginWithRedirect = function (credential) {
        var _this = this;
        var _a = this.prepareRedirect(credential), redirectUrl = _a.redirectUrl, state = _a.state;
        this.requestClient.getBaseURL().then(function (baseUrl) {
            _this.jsdomWindow.location.replace(baseUrl +
                _this.browserAuthRoutes.getAuthProviderRedirectRoute(credential, redirectUrl, state, _this.deviceInfo));
        });
    };
    StitchAuthImpl.prototype.linkWithRedirectInternal = function (user, credential) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, redirectUrl, state, baseUrl, link;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (this.user !== undefined && user.id !== this.user.id) {
                            return [2, Promise.reject(new StitchClientError(StitchClientErrorCode.UserNoLongerValid))];
                        }
                        _a = this.prepareRedirect(credential), redirectUrl = _a.redirectUrl, state = _a.state;
                        return [4, this.requestClient.getBaseURL()];
                    case 1:
                        baseUrl = _b.sent();
                        link = baseUrl +
                            this.browserAuthRoutes.getAuthProviderLinkRedirectRoute(credential, redirectUrl, state, this.deviceInfo);
                        return [2, (StitchAuthImpl.injectedFetch ? StitchAuthImpl.injectedFetch : fetch)(new Request(link, {
                                credentials: "include",
                                headers: {
                                    Authorization: "Bearer " + this.authInfo.accessToken
                                },
                                mode: 'cors'
                            })).then(function (response) {
                                _this.jsdomWindow.location.replace(response.headers.get("X-Stitch-Location"));
                            })];
                }
            });
        });
    };
    StitchAuthImpl.prototype.hasRedirectResult = function () {
        var isValid = false;
        try {
            isValid = this.parseRedirect().isValid;
            return isValid;
        }
        catch (_) {
            return false;
        }
        finally {
            if (!isValid) {
                this.cleanupRedirect();
            }
        }
    };
    StitchAuthImpl.prototype.handleRedirectResult = function () {
        try {
            var providerName = this.authStorage.get(RedirectKeys.ProviderName);
            var providerType = this.authStorage.get(RedirectKeys.ProviderType);
            var redirectFragment = this.parseRedirect();
            return this.loginWithCredentialInternal(new StitchAuthResponseCredential(this.processRedirectResult(redirectFragment), providerType, providerName, redirectFragment.asLink)).then(function (user) {
                return user;
            });
        }
        catch (err) {
            return Promise.reject(err);
        }
    };
    StitchAuthImpl.prototype.linkWithCredential = function (user, credential) {
        return _super.prototype.linkUserWithCredentialInternal.call(this, user, credential);
    };
    StitchAuthImpl.prototype.logout = function () {
        return Promise.resolve(_super.prototype.logoutInternal.call(this));
    };
    Object.defineProperty(StitchAuthImpl.prototype, "deviceInfo", {
        get: function () {
            var info = {};
            if (this.hasDeviceId) {
                info[DeviceFields.DEVICE_ID] = this.deviceId;
            }
            if (this.appInfo.localAppName !== undefined) {
                info[DeviceFields.APP_ID] = this.appInfo.localAppName;
            }
            if (this.appInfo.localAppVersion !== undefined) {
                info[DeviceFields.APP_VERSION] = this.appInfo.localAppVersion;
            }
            var browser = detect();
            if (browser) {
                info[DeviceFields.PLATFORM] = browser.name;
                info[DeviceFields.PLATFORM_VERSION] = browser.version;
            }
            else {
                info[DeviceFields.PLATFORM] = "web";
                info[DeviceFields.PLATFORM_VERSION] = "0.0.0";
            }
            info[DeviceFields.SDK_VERSION] = version;
            return info;
        },
        enumerable: true,
        configurable: true
    });
    StitchAuthImpl.prototype.addAuthListener = function (listener) {
        this.listeners.add(listener);
        this.onAuthEvent(listener);
    };
    StitchAuthImpl.prototype.removeAuthListener = function (listener) {
        this.listeners.delete(listener);
    };
    StitchAuthImpl.prototype.onAuthEvent = function (listener) {
        var _this = this;
        if (listener) {
            var auth_1 = this;
            var _1 = new Promise(function (resolve) {
                listener.onAuthEvent(auth_1);
                resolve(undefined);
            });
        }
        else {
            this.listeners.forEach(function (one) {
                _this.onAuthEvent(one);
            });
        }
    };
    StitchAuthImpl.prototype.cleanupRedirect = function () {
        this.jsdomWindow.history.replaceState(null, "", this.pageRootUrl());
        this.authStorage.remove(RedirectKeys.State);
        this.authStorage.remove(RedirectKeys.ProviderName);
        this.authStorage.remove(RedirectKeys.ProviderType);
    };
    StitchAuthImpl.prototype.parseRedirect = function () {
        if (typeof this.jsdomWindow === "undefined") {
            throw new StitchRedirectError("running in a non-browser environment");
        }
        if (!this.jsdomWindow.location || !this.jsdomWindow.location.hash) {
            throw new StitchRedirectError("window location hash was undefined");
        }
        var ourState = this.authStorage.get(RedirectKeys.State);
        var redirectFragment = this.jsdomWindow.location.hash.substring(1);
        return parseRedirectFragment(redirectFragment, ourState, this.appInfo.clientAppId);
    };
    StitchAuthImpl.prototype.processRedirectResult = function (redirectFragment) {
        try {
            if (!redirectFragment.isValid) {
                throw new StitchRedirectError("invalid redirect result");
            }
            if (redirectFragment.lastError) {
                throw new StitchRedirectError("error handling redirect: " + redirectFragment.lastError);
            }
            if (!redirectFragment.authInfo) {
                throw new StitchRedirectError("no user auth value was found: it could not be decoded from fragment");
            }
        }
        catch (err) {
            throw err;
        }
        finally {
            this.cleanupRedirect();
        }
        return redirectFragment.authInfo;
    };
    StitchAuthImpl.prototype.prepareRedirect = function (credential) {
        this.authStorage.set(RedirectKeys.ProviderName, credential.providerName);
        this.authStorage.set(RedirectKeys.ProviderType, credential.providerType);
        var redirectUrl = credential.redirectUrl;
        if (redirectUrl === undefined) {
            redirectUrl = this.pageRootUrl();
        }
        var state = generateState();
        this.authStorage.set(RedirectKeys.State, state);
        return { redirectUrl: redirectUrl, state: state };
    };
    StitchAuthImpl.prototype.pageRootUrl = function () {
        return [
            this.jsdomWindow.location.protocol,
            "//",
            this.jsdomWindow.location.host,
            this.jsdomWindow.location.pathname
        ].join("");
    };
    return StitchAuthImpl;
}(CoreStitchAuth));
export default StitchAuthImpl;
function generateState() {
    var state = "";
    for (var i = 0; i < 64; ++i) {
        state += alphaNumericCharacters.charAt(Math.floor(Math.random() * alphaNumericCharacters.length));
    }
    return state;
}
function unmarshallUserAuth(data) {
    var parts = data.split("$");
    if (parts.length !== 4) {
        throw new StitchRedirectError("invalid user auth data provided while " +
            "marshalling user authentication data: " +
            data);
    }
    var accessToken = parts[0], refreshToken = parts[1], userId = parts[2], deviceId = parts[3];
    return new AuthInfo(userId, deviceId, accessToken, refreshToken);
}
var ParsedRedirectFragment = (function () {
    function ParsedRedirectFragment() {
        this.stateValid = false;
        this.clientAppIdValid = false;
        this.asLink = false;
    }
    Object.defineProperty(ParsedRedirectFragment.prototype, "isValid", {
        get: function () {
            return this.stateValid && this.clientAppIdValid;
        },
        enumerable: true,
        configurable: true
    });
    return ParsedRedirectFragment;
}());
function parseRedirectFragment(fragment, ourState, ourClientAppId) {
    var vars = fragment.split("&");
    var result = new ParsedRedirectFragment();
    vars.forEach(function (kvp) {
        var pairParts = kvp.split("=");
        var pairKey = decodeURIComponent(pairParts[0]);
        switch (pairKey) {
            case RedirectFragmentFields.StitchError:
                result.lastError = decodeURIComponent(pairParts[1]);
                break;
            case RedirectFragmentFields.UserAuth:
                try {
                    result.authInfo = unmarshallUserAuth(decodeURIComponent(pairParts[1]));
                }
                catch (e) {
                    result.lastError = e;
                }
                break;
            case RedirectFragmentFields.StitchLink:
                if (pairParts[1] == "ok") {
                    result.asLink = true;
                }
                break;
            case RedirectFragmentFields.State:
                var theirState = decodeURIComponent(pairParts[1]);
                if (ourState === theirState) {
                    result.stateValid = true;
                }
                break;
            case RedirectFragmentFields.ClientAppId:
                var clientAppId = decodeURIComponent(pairParts[1]);
                if (ourClientAppId === clientAppId) {
                    result.clientAppIdValid = true;
                }
                break;
            default:
                break;
        }
    });
    return result;
}
function isAuthProviderClientFactory(factory) {
    return (factory.getClient !== undefined);
}
//# sourceMappingURL=StitchAuthImpl.js.map